import { Pipe, PipeTransform } from '@angular/core';
import { ImageSchema, ImageTranslatableSchema } from '@app/schemas/image';

@Pipe({
  name: 'imageTranslate',
})
export class ImageTranslatePipe implements PipeTransform {

  public transform(image: ImageTranslatableSchema, lang: string | 'fallback'): ImageSchema {
    if (lang === 'fallback') {
      return image.translations[image.fallback];
    }

    return image.translations[lang] || image.translations[image.fallback];
  }

}
